import { render, staticRenderFns } from "./BundleSmallToModalButton.vue?vue&type=template&id=5ab7089e&scoped=true&"
import script from "./BundleSmallToModalButton.vue?vue&type=script&lang=js&"
export * from "./BundleSmallToModalButton.vue?vue&type=script&lang=js&"
import style0 from "./BundleSmallToModalButton.vue?vue&type=style&index=0&id=5ab7089e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab7089e",
  null
  
)

export default component.exports